import { render, staticRenderFns } from "./imageUploader2.vue?vue&type=template&id=184747c4&scoped=true"
import script from "./imageUploader2.vue?vue&type=script&lang=js"
export * from "./imageUploader2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184747c4",
  null
  
)

export default component.exports